<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="author"><a id="page_v"></a><strong>Author’s Note</strong></h2>
<p class="noindent">The trilevel presentation of an imaginary West Indian dialect (provincial, standardized provincial, standard) is an intentional—and, the writer hopes, comprehensible—act of bridging between popular and conventional usage.</p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?8e624534